export default function useTenant(unit) {

  const setChildrenData = (item, actions) => {

  }

  const actions = (item, vm, isDnd = false) => {
  };

  return { setChildrenData, actions};
}
